import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import localeDe from '@angular/common/locales/de';
import { NgxMaskConfig } from 'ngx-mask';

export const SupportedLocales = {
    DE: 'de',
    EN: 'en',
} as const;

export const ALL_SUPPORTED_LOCALES = Object.values(SupportedLocales) as SupportedLocale[];

export type SupportedLocale = typeof SupportedLocales[keyof typeof SupportedLocales];

const AngularLocales: Record<SupportedLocale, unknown> = {
    [SupportedLocales.DE]: localeDe,
    [SupportedLocales.EN]: localeEnGb,
};

export const ngxMaskConfigRegistry: Record<SupportedLocale, Partial<NgxMaskConfig>> = {
    [SupportedLocales.DE]: {
        thousandSeparator: '.',
        decimalMarker: ',',
    },
    [SupportedLocales.EN]: {
        thousandSeparator: ',',
        decimalMarker: '.',
    },
};

// This updates what locales we explicitly support to Angular with which locale ID (which can be an alias).
// For instance, we can do `registerLocaleData(localeFrGa, 'fr')` which allows to use the data for fr-GA for 'fr'
// instead of whatever default 'fr' corresponds to.
//
// Those locales are not absolute: in the end it defines what locale is used to instantiate the Intl object, for which
// the locales depend on the Browser used when in the browser or the icu-data configured for node when in node.
//
// TL:DR; those offers no guarantee. If the actual desired locale is not installed for the browser/node, a fallback
// is silently used. And ultimately, there is always _one_ locale available. So if you request to language Chrome
// with the language 'fr-GA' but it is not available, at no point a failure will be raised, it will just use the
// next locale available.
export function registerSupportedLocalesData(): void {
    for (const [localId, localeData] of Object.entries(AngularLocales)) {
        registerLocaleData(localeData, localId);
    }
}
